<template>
  <v-row class="header">
    <div class="container">
      <img src="@/assets/images/marsh_logo.png" class="img-responsive" />
      <h2>{{ $t("lang.header.title") }}</h2>
      <span
        class="xs-hidden"
        v-if="$store.state.submissionId === null"
        @click="goMarshHome"
        >{{ $t("lang.header.cancel") }}</span
      >
      <span class="cross-icon cancel" @click="goMarshHome"></span>
    </div>
  </v-row>
</template>

<script>
export default {
  name: "Header",
  methods: {
    goMarshHome: function() {
      const locale = this.$store.state.country
      const prodURL = {
        hk: "https://www.marsh.com/hk/en/industries/marine/products/yachtcover.html",
        sg: "https://www.marsh.com/sg/industries/marine/products/yachtcover.html",
        th: "https://www.marsh.com/th/en/industries/marine/products/yachtcover.html"
      };
      // const nonProdURL =  {
      //   hk: "https://author.www.marshinc.net/content/marsh/blueprints1/as/en/industries/marine/yachtcover.html",
      //   sg: "https://author.www.marshinc.net/content/marsh/asia/sg/en_sg/industries/marine/yachtcover.html?wcmmode=disabled"
      // };
      window.location.href = prodURL[locale];
      // if(location.hostname === "yachtcover.map.marsh.com") {
      //   window.location.href = prodURL[locale];
      // } else {
      //   window.location.href = nonProdURL[locale];
      // }
    },
  },
};
</script>
